import { render, staticRenderFns } from "./black-bar.vue?vue&type=template&id=404f4b5d"
import script from "./black-bar.vue?vue&type=script&lang=js"
export * from "./black-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports